import React, { useState } from 'react';
import { Nav, TabContent } from 'reactstrap';
import { Page, NavItem, TabPane } from "components/common";
import List from "./ListInvoices";
import ListCreditNotes from "./ListCreditNotes";
import Repeating from "./Repeating";
import { Switch, Redirect } from "react-router-dom";
import { useNonReportedTotals } from 'hooks/useNonReportedTotals';
import Warning from './Warning';
import { Trans } from 'react-i18next';


// Used for routes
export EditInvoice from "./EditInvoice";
export EditCreditNote from "./EditCreditNote";
export AllocateCredit from "./AllocateCredit";
export Repeating from "./Repeating";
export EditRepeating from "./EditRepeating";
export ViewRepeating from "./ViewRepeating";
export ViewEInvoice from "./ViewEInvoice";
export ViewCreditNote from "./ViewCreditNote";

export const Landing = ({ match }) => {
  const { data, refetch } = useNonReportedTotals();
  
  return (
    <Page>
      <div className='inv-tabs'>
        <Nav tabs className="mb-2">
          <NavItem to={`/accounts_receivable/invoices`} translate={false}>
            <Trans>Sales invoices</Trans>
            <Warning total_non_reported={data?.invoices?.itemCount} />
          </NavItem>
          <NavItem to={`/accounts_receivable/credit_notes`} translate={false}>
            <Trans>Sales Credit Notes</Trans>
            <Warning total_non_reported={data?.creditNotes?.itemCount} />
          </NavItem>
          <NavItem to={`/accounts_receivable/repeating`}>
            Repeating Invoices
          </NavItem>
        </Nav>
        <TabContent>
          <Switch>
            <TabPane path={`/accounts_receivable/invoices`} component={List} match={match} exact={false}/>
            <TabPane path={`/accounts_receivable/credit_notes`} component={ListCreditNotes} match={match} exact={false}/>
            <TabPane path={`/accounts_receivable/repeating`} component={Repeating} match={match} exact={false}/>
            <Redirect to={`/accounts_receivable/invoices`} />
          </Switch>
        </TabContent>
      </div>
    </Page>
  );
}